import { RCItemType } from "src/types/RCItemType";
import BaseApi from "src/store/BaseApi";
const PrivateAPIWithTags = BaseApi.enhanceEndpoints({
  addTagTypes: ["userDetails"],
});


export const TopupApis = PrivateAPIWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getTopupCategories: builder.query<{ categories: { code: string; name: string }[]; count: number }, any>({
      keepUnusedDataFor: 600,
      query: ({ Page, PageSize }) => {
        return {
          url: `v1.0/Category`,
          method: "POST",
          body: { Page, PageSize },
        };
      },
      transformResponse: (response: any) => {
        return {
          categories: response.result.data,
          count: response.result.count,
        };
      },
      extraOptions: {
        notifyOnFailure: true,
      },
    }),
    getTopupItemDetails: builder.query<RCItemType[], any>({
      keepUnusedDataFor: 600,
      query: (body) => {
        return {
          url: `v1.0/Item/Details`,
          method: "POST",
          body,
        };
      },
      transformResponse: (response: any) => {
        return response.result.data;
      },
      extraOptions: {
        notifyOnFailure: true,
      },
    }),
    getTopupWithDetails: builder.query<any[], any>({
      keepUnusedDataFor: 600,
      query: (body) => {
        return {
          url: `v1.0/Item/WithDetails`,
          method: "POST",
          body,
        };
      },
      transformResponse: (response: any) => {
        return response.result.data;
      },
      extraOptions: {
        notifyOnFailure: true,
      },
    }),
    checkout: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/Order/Checkout`,
          method: "POST",
          body,
        };
      },
      transformResponse: (response: any) => {
        return response?.result;
      },
      invalidatesTags: ["userDetails"],
      extraOptions: {
        notifyOnFailure: true,
      },
    }),
  }),
});

type TopupApiEndpoints = keyof typeof TopupApis.endpoints;

export { type TopupApiEndpoints };
export const { useGetTopupCategoriesQuery, useGetTopupItemDetailsQuery, useGetTopupWithDetailsQuery, useCheckoutMutation } = TopupApis;
